// @ts-ignore react-ionicions has no exported @types/
import Ionicon from 'react-ionicons'

export default Ionicon
